var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TagsToChart',{staticClass:"tags",attrs:{"data":_vm.tags,"height":1500}})
}
var staticRenderFns = []

export { render, staticRenderFns }